module.exports = __webpack_public_path__ + "img/data-item6-1.893d1e3.png";